import React from 'react';

class Pagination extends React.Component {
    constructor(props) {
        super(props);

        const { pageNr, numberOfPages } = this.props;
        const pageNumber = this.checkPageNumber(pageNr, numberOfPages);
        const completeRange = this.getCompleteRange(pageNumber, numberOfPages);

        this.state = {
            pageNr: pageNumber,
            totalNumberOfPages: numberOfPages,
            rangeWithDots: completeRange,
        };
    }

    pageNumbers = (newPageNumber, e) => {
        e.preventDefault();
        const { handlePagination } = this.props;
        const { totalNumberOfPages } = this.state;

        newPageNumber = this.checkPageNumber(newPageNumber, totalNumberOfPages);
        const completeRange = this.getCompleteRange(newPageNumber, totalNumberOfPages);

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });

        this.setState(
            {
                rangeWithDots: completeRange,
            },
            () => handlePagination(newPageNumber),
        );
    };

    checkPageNumber = (newPageNumber, totalNumberOfPages) => {
        if (newPageNumber >= totalNumberOfPages) {
            newPageNumber = totalNumberOfPages;
        } else if (newPageNumber < 1) {
            newPageNumber = 1;
        }
        return newPageNumber;
    };

    getCompleteRange = (current, totalNumberOfPages) => {
        const pagesBeforeAndAfter = 2;
        const minPage = current - pagesBeforeAndAfter;
        const maxPage = current + pagesBeforeAndAfter + 1;
        const range = [];
        const completeRange = [];
        let l;

        if (totalNumberOfPages > 9) {
            for (let i = 1; i <= totalNumberOfPages; i++) {
                if (i === 1 || i === totalNumberOfPages || (i >= minPage && i < maxPage)) {
                    range.push(i);
                }
            }
        } else {
            for (let i = 1; i <= totalNumberOfPages; i++) {
                range.push(i);
            }
        }

        for (let i of range) {
            if (l) {
                if (i - l === 2) {
                    completeRange.push(l + 1);
                } else if (i - l !== 1) {
                    completeRange.push('...');
                }
            }

            completeRange.push(i);
            l = i;
        }

        return completeRange;
    };

    renderPageNumbers = () => {
        const { pageNr } = this.props;
        const { rangeWithDots } = this.state;

        return rangeWithDots.map((item, index) => {
            if (item === '...') {
                return (
                    <div className="sfr-pagination__ellipsis" key={item + index}>
                        {item}
                    </div>
                );
            } else {
                const isActive = pageNr === item;

                return (
                    <a
                        href={`?page=${item}`}
                        className={`sfr-pagination__number ${isActive ? 'active' : ''}`}
                        onClick={(e) => this.pageNumbers(item, e)}
                        key={item + index}
                    >
                        {item}
                    </a>
                );
            }
        });
    };

    render() {
        const { resourcedTexts, pageNr } = this.props;
        const { totalNumberOfPages } = this.state;

        const prevPageNr = pageNr - 1;
        const nextPageNr = pageNr + 1;
        const isFirstPage = pageNr <= 1;
        const isLastPage = pageNr >= totalNumberOfPages;

        return (
            <div className="sfr-pagination">
                <a
                    href={!isFirstPage ? `?page=${prevPageNr}` : ''}
                    className={`sfr-pagination__prev ${isFirstPage ? 'inactive' : ''}`}
                    onClick={(e) => this.pageNumbers(prevPageNr, e)}
                >
                    <span>{resourcedTexts.previous}</span>
                </a>

                <div className="sfr-pagination__numbers">{this.renderPageNumbers()}</div>

                <a
                    href={!isLastPage ? `?page=${nextPageNr}` : ''}
                    className={`sfr-pagination__next ${isLastPage ? 'inactive' : ''}`}
                    onClick={(e) => this.pageNumbers(nextPageNr, e)}
                >
                    <span>{resourcedTexts.next}</span>
                </a>
            </div>
        );
    }
}

export { Pagination };
